import { writable } from "svelte/store";

const id = new writable("")

export default id;